import { Routes } from '@angular/router';
import { ACCOUNT_ROUTES } from './account/account.routes';
import { USER_ROUTES } from './user/user.routes';

export const ACCOUNT_USER_ROUTES: Routes = [...ACCOUNT_ROUTES, ...USER_ROUTES];
